import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import Paper from '@material-ui/core/Paper'
import SkeletonItem from './skeletonItem'
import useStyles from './stylesList'

const TOTAL_ITEMS = 10

const CheckboxList = props => {
  const { height, isLoading, children } = props
  const classes = useStyles()
  const skeletonItems = useMemo(() => {
    return Array.from(Array(TOTAL_ITEMS).keys()).map((_, i) => (
      <SkeletonItem key={`skeleton-${i}`} />
    ))
  }, [])

  return (
    <Box mb={3} className={classes.root}>
      {isLoading ? (
        <Paper style={{ maxHeight: height, overflow: 'auto' }}>
          {skeletonItems}
        </Paper>
      ) : (
        <Paper style={{ maxHeight: height, overflow: 'auto' }}>
          <List role="list" disablePadding>
            {children}
          </List>
        </Paper>
      )}
    </Box>
  )
}

CheckboxList.propTypes = {
  height: PropTypes.number,
  isLoading: PropTypes.bool,
}

export default CheckboxList
